import React from "react"
import AppCtaBanner from "./index"

const en = {
  title: "Download the best travel and lifestyle app here",
  description:
    "Go further. Be more adventurous. A world of opportunities awaits within the airasia.com mobile app!",
}

const id_id = {
  title: "Unduh aplikasi perjalanan dan gaya hidup terbaik di sini",
  description:
    "Pergi lebih jauh. Bertualang lebih berani. Sebuah dunia penuh peluang menunggu dalam aplikasi seluler airasia.com!",
}

const th_th = {
  title: "ดาวน์โหลดแอพท่องเที่ยวและแพลตฟอร์มไลฟ์สไตล์ที่ดีที่สุดได้ที่นี่",
  description:
    "ไปได้ไกลกว่าเดิม สัมผัสความตื่นเต้นที่มากขึ้น โลกแห่งโอกาสรอคุณอยู่ที่ airasia.com โมบายแอพ",
}

const ko_kr = {
  title: "여기에서 최고의 여행 및 라이프스타일 앱을 다운로드하세요.",
  description:
    "더 많이 여행해보세요. 모험심을 더 가져보세요. Airasia.com 모바일 앱에서 다양한 기회들이 기다리고 있습니다!",
}

const zh_hk = {
  title: "在此處下載最佳旅行及生活應用程式",
  description:
    "走遠一點。更大膽一點。大量機會盡在 airasia.com 流動應用程式等您！",
}

const zh_cn = {
  title: "点击此处下载最好的旅游和生活方式应用程序",
  description:
    "继续前行！多点冒险精神！通过airasia.com移动应用程序探索这个充满机会的世界！",
}

const zh_tw = {
  title: "在此處下載最佳的旅遊和生活應用程式",
  description:
    "走遠一點。更大膽一點。滿滿的機會就在 airasia.com 行動應用程式內等著您！",
}

const ja_jp = {
  title: "最高の旅行＆ライフスタイルアプリのダウンロードはこちら",
  description:
    "もっと先へ。もっと冒険しよう。airasia.com モバイルアプリでは、そのチャンスがあなたを待っています！",
}

export const AppCtaDesktopWrapper = {
  "/": <AppCtaBanner {...en} />,
  "/id/id": <AppCtaBanner {...id_id} />,
  "/th/th/": <AppCtaBanner {...th_th} />,
  "/ja/jp/": <AppCtaBanner {...ja_jp} />,
  "/ko/kr/": <AppCtaBanner {...ko_kr} />,
  "/zh/tw/": <AppCtaBanner {...zh_tw} />,
  "/zh/hk/": <AppCtaBanner {...zh_hk} />,
  "/zh/cn/": <AppCtaBanner {...zh_cn} />,
}

export const AppCtaMobileWrapper = {
  "/": <AppCtaBanner {...en} isMobile={true} />,
  "/id/id/": <AppCtaBanner {...id_id} isMobile={true} />,
  "/th/th/": <AppCtaBanner {...th_th} isMobile={true} />,
  "/ja/jp/": <AppCtaBanner {...ja_jp} isMobile={true} />,
  "/ko/kr/": <AppCtaBanner {...ko_kr} isMobile={true} />,
  "/zh/tw/": <AppCtaBanner {...zh_tw} isMobile={true} />,
  "/zh/hk/": <AppCtaBanner {...zh_hk} isMobile={true} />,
  "/zh/cn/": <AppCtaBanner {...zh_cn} isMobile={true} />,
}
